import Cookies from "js-cookie"

var aosPopup = document.querySelector("#aosPopup")
var aosDismiss = document.querySelector("#aosDismiss")
var aosBackdrop = document.querySelector("#aosBackdrop")
var body = document.querySelector("body")

body.classList.add("overflow-hidden")

aosDismiss.addEventListener("click", () => {
	Cookies.set("aos", "shown", { expires: 7 })
	body.classList.remove("overflow-hidden")
})

aosBackdrop.addEventListener("click", () => {
	Cookies.set("aos", "shown", { expires: 7 })
	body.classList.remove("overflow-hidden")
})

if (Cookies.get("aos")) {
	aosPopup.classList.add(
		"hidden",
		"invisible",
		"pointer-events-none",
		"scale-0"
	)
	body.classList.remove("overflow-hidden")
} else {
	aosPopup.classList.remove(
		"hidden",
		"invisible",
		"pointer-events-none",
		"scale-0"
	)
	body.classList.add("overflow-hidden")
}

document.addEventListener("keyup", ({ key }) => {
	if (key === "Escape") {
		Cookies.set("aos", "shown", { expires: 7 })
		body.classList.remove("overflow-hidden")
	}
})
